import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'ProductTags',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getProductTagSuccess(state, action) {
      state.data = action.payload.data;
    },
    getAllProductTagSuccess(state, action) {
      state.allData = action.payload.data;
    },

    addOrUpdateProductTag(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllProductTag() {
  return async () => {
    try {
      const response = await get(`productTag`);
      if (response.status) {
        dispatch(slice.actions.getAllProductTagSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getProductTag() {
  return async () => {
    try {
      const response = await get(`productTag`);
      if (response.status) {
        dispatch(slice.actions.getProductTagSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addProductTag(body) {
  return async () => {
    try {
      const response = await post(`ProductTag`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateProductTag(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateProductTag(body) {
  return async () => {
    try {
      const response = await put(`ProductTag`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateProductTag(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
